module.exports = __webpack_public_path__ + "static/media/caredependents.4709a9b9.png";